import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Row, Col, FormText, FormGroup, Input, Label, Spinner, Alert } from 'reactstrap';
import { Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getUsers } from 'app/shared/reducers/user-management';
import { ITopic } from 'app/shared/model/topic.model';
import { getEntities as getTopics } from 'app/entities/topic/topic.reducer';
import { createEntity, reset, getEntityProfileDetails, updateEntityUserType } from 'app/entities/user-profile/user-profile.reducer';
import { createEntityMenteeQuestions } from 'app/entities/question/question.reducer';
import { createEntityMentorTopic } from 'app/entities/mentor-topic/mentor-topic.reducer';
import { createEntityMenteeTopic } from 'app/entities/mentee-topic/mentee-topic.reducer';
import { Country, State, City } from 'country-state-city';
import { ICountry, IState, ICity } from 'country-state-city';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { AGE_TEXT_QUEST, AUTHORITIES } from 'app/config/constants';
import axios from 'axios';
import TermsModal from 'app/shared/modal/TermsModal';
import { useEnhanceWithAI } from '../../hooks/useEnhanceWithAI';
import Select, { components } from 'react-select';
const Option = props => (
  <components.Option {...props}>
    <input type="checkbox" checked={props.isSelected} onChange={() => null} style={{ marginRight: 8 }} />
    <label>{props.label}</label>
  </components.Option>
);
export const UserOnBoradForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [isChecked, setIsChecked] = useState(false);
  const [showInputs, setShowInputs] = useState(false);
  const users = useAppSelector(state => state.userManagement.users);
  const topics = useAppSelector(state => state.topic.entities);
  const userProfileEntity = useAppSelector(state => state.userProfile.entity);
  const loading = useAppSelector(state => state.userProfile.loading);
  const [loadingMain, setLoadingMain] = useState(false);
  const [questionErrors, setQuestionErrors] = useState<any>({});
  // const [loadingMainAI, setLoadingMainAI] = useState(false);
  const updating = useAppSelector(state => state.userProfile.updating);
  const updateSuccess = useAppSelector(state => state.userProfile.updateSuccess);
  const account = useAppSelector(state => state.authentication.account);
  const [selectedTopics, setSelectedTopics] = useState<ITopic[]>([]);
  const [selectedCountry, setSelectedCountry] = useState<ICountry | null>(null);
  const [selectedState, setSelectedState] = useState<IState | null>(null);
  const [selectedYear, setSelectedYear] = useState<number>();
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const id = account.id;
  const isNew = undefined;
  const [currentDecadeField, setCurrentDecadeField] = useState([]);
  // const [loadingIndex, setLoadingIndex] = useState<number>();
  const [userloading, setUserloading] = useState(true);
  const [loadingForm, setLoadingForm] = useState(true);
  const baseImageUrl = '/profile/get/image';
  const { loadingMainAI, loadingIndex, enhanceWithAIHandler, enhanceQuestionWithAI } = useEnhanceWithAI();
  const topicOptions = topics.map(topic => ({
    value: topic.id,
    label: topic.name,
  }));
  const selectedTopicOptions = selectedTopics.map(topic => ({
    value: topic.id,
    label: topic.name,
  }));
  const [isMentee, setIsMentee] = useState(false);
  const [fields, setFields] = useState([
    { name: '', value: '' },
    { name: '', value: '' },
    { name: '', value: '' },
    { name: '', value: '' },
    { name: '', value: '' },
  ]);
  const [termsOpen, setTermsOpen] = useState(false);
  const [isAccepted, setIsAccepted] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);

  const startYear = 1923; // Change this value as per your requirement
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - startYear + 1 }, (_, index) => startYear + index);
  useEffect(() => {
    dispatch(getEntityProfileDetails(id));
    const countries = Country.getAllCountries();
    setSelectedCountry(countries[0]);
  }, []);

  const handleCountryChange = (countryName: string) => {
    const newCountry = Country.getAllCountries().find(country => country.name === countryName);
    if (newCountry) {
      setSelectedCountry(newCountry);
      setSelectedState(null);
    }
  };
  const handleStateChange = (state: IState) => {
    setSelectedState(state);
  };
  const handleTopicSelect = selectedOptions => {
    //  Convert React Select format back to raw ITopic format
    const selected = (selectedOptions || []).map(opt => topics.find(t => t.id === opt.value)).filter(Boolean);

    if (selected.length <= 10) {
      setSelectedTopics(selected);
    }
  };
  useEffect(() => {
    if (userProfileEntity?.length > 0) {
      const userinfo = userProfileEntity[0];
      if (userinfo.year) {
        navigate('/user-profile/' + userinfo.user.id);
      }
    }
    const countries = Country.getAllCountries();
    setUserloading(false);
  }, [userProfileEntity, navigate]);
  const handleClose = () => {
    const userinfo_close = userProfileEntity;
    navigate('/user-profile/' + userinfo_close.user.id);
  };
  const handleQuesionsInputChange = (index, event) => {
    const newValue = event.target.value;
    const updatedFields = [...fields];
    updatedFields[index].value = newValue;
    updatedFields[index].name = `question_${index + 1}`;

    setFields(updatedFields);
    if (newValue.trim() !== '') {
      setQuestionErrors(prev => {
        const updatedErrors = { ...prev };
        delete updatedErrors[index];
        return updatedErrors;
      });
    }
  };
  const handleDesInputChange = (index, event) => {
    const newValue = event.target.value;
    const updatedFields = [...currentDecadeField];
    updatedFields[index].value = newValue;

    setCurrentDecadeField(updatedFields);
  };
  const handleYearChange = value => {
    const selectedYearcurrent = parseInt(value);
    value != '' ? setSelectedYear(selectedYearcurrent) : setSelectedYear(undefined);

    const currentYear = new Date().getFullYear();
    const age = currentYear - value;

    const fieldGroups = [];
    for (let decade = 20; decade <= age; decade += 10) {
      const fieldGroup = {
        decade,
        name: `selfDescription${decade}`,
        label: `${AGE_TEXT_QUEST} ${decade}'s`,
        type: 'textarea',
        loadingAI: false,
        enhanceWithAI: true,
      };
      fieldGroups.push(fieldGroup);
    }
    setCurrentDecadeField(fieldGroups);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
      setLoadingForm(false); // Set loadingForm to false once form initialization is done
    } else {
      dispatch(getEntityProfileDetails(id)).then(() => setLoadingForm(false)); // Set loadingForm to false after profile details are fetched
    }
    dispatch(getUsers({}));
    dispatch(getTopics({ page: 0, size: 100, sort: 'id,asc' }));
  }, [isNew, id, dispatch]);

  useEffect(() => {
    setShowInputs(isChecked);
  }, [isChecked]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = async values => {
    if (isMentee) {
      const errors = {};

      for (let i = 0; i < 3; i++) {
        if (!fields[i]?.value || fields[i].value.trim() === '') {
          errors[i] = 'Please enter a question.';
        }
      }

      setQuestionErrors(errors);
      if (Object.keys(errors).length > 0) {
        return;
      }
    }
    if (!isAccepted) {
      setTermsOpen(true);
      setPendingValues(values);
      return;
    }

    const entity = {
      ...userProfileEntity,
      ...values,
      user: { id: account.id },
      questions: fields.map(field => field.value?.trim()).filter(question => question !== ''),
      isMentor: isMentee ? false : true,
      year: selectedYear,
      termsAccepted: isAccepted,
      ...currentDecadeField.reduce((acc, { name, value }) => {
        acc[name] = value;
        return acc;
      }, {}),
    };
    selectedTopics.map(async (topic, index) => {
      const topics = {
        user: { id: account.id },
        topic: { id: topic.id, name: topic.name },
      };

      await dispatch(createEntityMentorTopic(topics));
    });
    setLoadingMain(true);
    await dispatch(createEntity(entity));
    setLoadingMain(false);
    if (isMentee) {
      if (fields.length > 0) {
        fields
          .filter(item => item.value && item.value.trim() !== '')
          .map(async item => {
            const question = {
              user: { id: account.id },
              question: item.value.trim(),
            };
            //console.log(question, 'question');
            await dispatch(createEntityMenteeQuestions(question));
          });
      }
      if (selectedTopics.length > 0) {
        selectedTopics.map(async (topic, index) => {
          const topics = {
            user: { id: account.id },
            topic: { id: topic.id, name: topic.name },
          };
          await dispatch(createEntityMenteeTopic(topics));
        });
      }
    }
  };

  const defaultValues = () => {
    const test3 = isNew
      ? {}
      : {
          ...userProfileEntity,
          user: userProfileEntity?.user?.id,
          firstName: account.firstName,
          lastName: account.lastName,
          email: account.email,
          imageUrl: account.imageUrl,
          ...currentDecadeField.reduce((acc, { name, value }) => {
            acc[name] = value;
            return acc;
          }, {}),
        };
    return test3;
  };

  const handleAcceptTerms = () => {
    setTermsOpen(false);

    if (pendingValues) {
      const updatedValues = {
        ...pendingValues,
        termsAccepted: true,
      };

      saveEntity(updatedValues);
      setPendingValues(null);
    }
  };
  const handleCancelTerms = () => {
    setIsAccepted(false); // ✅ reset
    setTermsOpen(false);
  };

  return (
    <div className="container card fiveplus-small-screen profile-page">
      {loading || userloading ? (
        <Spinner className="body-loader-icon"></Spinner>
      ) : (
        <Row>
          <Col md="12">
            <h1 className="main-title d-flex justify-content-center">
              {/* <Translate contentKey="home.title">Sign In With LikedIN!</Translate> */}
              Welcome To <img className="home-logo" src="content/images/header-logo.svg"></img>
            </h1>
            <p id="fivePlusApp.userProfile.home.createOrEditLabel" className="form-description d-flex justify-content-center">
              We need a little extra information to find the perfect mentor for you.
            </p>
          </Col>
          <Col md="12" className="user-information-form">
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity} className="row">
              {isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="user-profile-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                  className="col-4"
                />
              ) : null}
              <div className="user-avtar pt-4 d-flex justify-content-center">
                {account && !!account.imageUrl && <img src={`${baseImageUrl}/${account.imageUrl}`} className="bg-info rounded-circle " />}
              </div>{' '}
              <div className="col-12 onboard-switch mt-5 mb-5">
                <FormGroup switch className="tabs-switch">
                  <Input
                    type="switch"
                    checked={isMentee}
                    onClick={() => {
                      setIsMentee(!isMentee);
                      setQuestionErrors({});
                      //dispatch(updateEntityUserType([id, isMentee]));
                    }}
                  />
                  <Label className="mentor-label">Mentor</Label>
                  <Label className="mentee-label">Mentee</Label>
                </FormGroup>
              </div>
              <ValidatedField
                label={'First Name'}
                id="user-profile-firstName"
                name="firstName"
                data-cy="firstName"
                type="text"
                className="col-4"
              />
              <ValidatedField
                label={'Last Name'}
                id="user-profile-lastName"
                name="lastName"
                data-cy="lastName"
                type="text"
                className="col-4"
              />
              <ValidatedField
                label={'Year Of Birth'}
                id="user-profile-year"
                name="year"
                data-cy="year"
                type="select"
                onChange={event => handleYearChange(event.target.value)}
                validate={{
                  required: { value: true, message: 'year is required' },
                }}
                errorMessage={{
                  required: 'year is required',
                }}
                className="col-4"
              >
                <option value="">Select a year</option>
                {years.map(year => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField label={'Email'} id="user-profile-email" name="email" data-cy="email" type="email" className="col-4" />
              {/* <ValidatedField
                label={translate('fivePlusApp.userProfile.phoneNumber')}
                id="user-profile-phoneNumber"
                name="phoneNumber"
                data-cy="phoneNumber"
                type="text"
                className="col-4"
                validate={{ pattern: /^(\([0-9]{3}\)|[0-9]{3})-?[0-9]{3}-?[0-9]{4}$/ }}
                errorMessage={{
                  validate: 'Please enter a valid phone number',
                }}
              /> */}
              <ValidatedField
                label={'Area of Expertise'}
                id="user-profile-occupation"
                name="occupation"
                data-cy="occupation"
                type="text"
                className="col-4"
                valid={false}
              />
              <Col md="12" className="mb-2">
                <div className="align-items-center d-flex form-title pb-3">
                  Address <hr className="w-100 m-0 ms-3" />
                </div>
              </Col>
              {/* <ValidatedField
                label={translate('fivePlusApp.userProfile.country')}
                id="user-profile-country"
                name="country"
                data-cy="country"
                type="select"
                className="col-4"
                value={selectedCountry?.name}
                // value={selectedCountry?.isoCode}
                onChange={e => {
                  const selectedCountryName = e.target.value;
                  handleCountryChange(selectedCountryName);
                }}
              >
                {Country.getAllCountries().map(country => (
                  <option key={country.isoCode} value={country.name}>
                    {country.name}
                  </option>
                ))}
              </ValidatedField> */}
              {/* <ValidatedField
                label={translate('fivePlusApp.userProfile.state')}
                id="user-profile-state"
                name="state"
                data-cy="state"
                type="select"
                className="col-4"
                value={selectedState?.isoCode}
                onChange={e => {
                  const selectedStateIsoCode = e.target.value;
                  handleStateChange(State.getStateByCodeAndCountry(selectedStateIsoCode, selectedCountry?.isoCode || ''));
                }}
              >
                {selectedCountry &&
                  State.getStatesOfCountry(selectedCountry.isoCode).map(state => {
                    return (
                      <option key={state.isoCode} value={state.isoCode}>
                        {state.name}
                      </option>
                    );
                  })}
              </ValidatedField> */}
              <ValidatedField
                label={translate('fivePlusApp.userProfile.zipCode')}
                id="user-profile-zipCode"
                name="zipCode"
                data-cy="zipCode"
                type="text"
                className="col-4"
                validate={{ pattern: /^(?:[A-Z]{1,2}\d[A-Z\d]? \d[A-Z]{2}|[0-9A-Za-z\s\-]+)$/i }}
                errorMessage={{
                  pattern: 'Please enter a valid ZIP code',
                }}
                valid={false}
              />
              <Col md="12" className="mb-2">
                <div className="align-items-center d-flex form-title pb-3">
                  <h3 className="pt-3">Details</h3> <hr className="w-100 m-0 ms-3" />
                </div>
              </Col>
              {/* <Row> */}
              <ValidatedField
                label={'instagram Id'}
                id="user-profile-instagramUrl"
                name="instagramUrl"
                data-cy="instagramUrl"
                type="text"
                className="col-4 pe-3"
                valid={false}
              />
              <ValidatedField
                label={'Personal Info Link'}
                id="personalInfoLink"
                name="personalInfoLink"
                data-cy="personalInfoLink"
                type="text"
                className="col-md-6 mb-3"
                validate={{
                  validate: value => {
                    if (!value) return true;

                    if (value.length > 2048) {
                      return 'URL cannot exceed 2048 characters';
                    }

                    try {
                      new URL(value);
                      return true;
                    } catch {
                      return 'Please enter a valid URL';
                    }
                  },
                }}
                valid={false}
              />
              {/* </Row> */}
              {selectedYear !== undefined &&
                currentDecadeField.length > 0 &&
                currentDecadeField.map((field, index) => (
                  <React.Fragment key={field.name}>
                    <ValidatedField
                      label={field.label}
                      id={`user-profile-${field.name}`}
                      name={field.name}
                      data-cy={field.name}
                      onChange={e => handleDesInputChange(index, e)}
                      type={field.type}
                      className="col-4"
                      value={field.value}
                    />
                    {field.loadingAI ? <Spinner className="loading-btn">Loading...</Spinner> : ''}
                    {field.enhanceWithAI && (
                      <Button
                        className="enhance-ai-btn"
                        disabled={currentDecadeField[index]?.loadingAI}
                        onClick={() => enhanceWithAIHandler(index, currentDecadeField, setCurrentDecadeField)}
                      >
                        Enhance with AI
                      </Button>
                    )}
                  </React.Fragment>
                ))}
              <ValidatedField
                label={'Community Engagement & 5 Causes to Support/Non Profits'}
                id="user-profile-helpCommunityDescription"
                name="helpCommunityDescription"
                data-cy="helpCommunityDescription"
                type="textarea"
                className="col-4"
              />
              <Col md="12" className="mb-2">
                <div className="align-items-center d-flex form-title pb-1">
                  <h3 className="pt-3 mb-0">Topics</h3>
                  <hr className="w-100 m-0 ms-3" />
                </div>

                {/* ✅ Live counter */}
                <small className="text-muted">{`${selectedTopics.length}/10 topics selected`}</small>
              </Col>
              <div id="topic-ques" className="mb-3">
                <Select
                  options={topicOptions}
                  isMulti
                  closeMenuOnSelect={false}
                  hideSelectedOptions={false}
                  components={{ Option }}
                  onChange={handleTopicSelect}
                  value={selectedTopicOptions}
                  placeholder="Select topics (max 10)..."
                  isOptionDisabled={option => selectedTopics.length >= 10 && !selectedTopics.some(t => t.id === option.value)}
                />

                {/* ✅ Better message */}
                {selectedTopics.length >= 10 && (
                  <small className="text-danger mt-1 d-block">Maximum 10 topics reached. Remove one to add another.</small>
                )}
              </div>
              {isMentee &&
                fields.map((field, index) => (
                  <React.Fragment key={index}>
                    <ValidatedField
                      type="text"
                      name={`question_${index}`}
                      label={`${index + 1}. Question For Mentor`}
                      value={field.value}
                      onChange={e => handleQuesionsInputChange(index, e)}
                      validate={{ required: true }}
                      autoFocus={index === fields.length - 1}
                    />
                    {questionErrors[index] && <span className="text-danger small text-start mb-2">{questionErrors[index]}</span>}
                    {loadingMainAI && loadingIndex === index ? (
                      <Spinner className="loading-btn mentee-loading-btn">Loading...</Spinner>
                    ) : (
                      ''
                    )}
                    <Button
                      className="enhance-ai-btn mentee-enhance-ai-btn"
                      disabled={loadingMainAI && loadingIndex === index}
                      onClick={() => enhanceQuestionWithAI(index, fields, setFields)}
                    >
                      Enhance with AI
                    </Button>
                  </React.Fragment>
                ))}
              {/* <ValidatedField
                label={'By checking this box you are agreeing to our terms of service'}
                id="user-profile-termsAccepted"
                name="termsAccepted"
                data-cy="termsAccepted"
                check
                type="checkbox"
                required
              /> */}
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                {/* <FontAwesomeIcon icon="save" />
                &nbsp; */}
                <Translate contentKey="entity.action.save">Submit</Translate>
              </Button>
            </ValidatedForm>
          </Col>
          {loadingMain ? (
            <div className="loader_custom">
              <Spinner>Loading...</Spinner>
            </div>
          ) : (
            ''
          )}
          <TermsModal
            isOpen={termsOpen}
            toggle={handleCancelTerms}
            onAccept={handleAcceptTerms}
            accepted={isAccepted}
            setAccepted={setIsAccepted}
            showCancel={true}
          />
        </Row>
      )}
    </div>
  );
};

export default UserOnBoradForm;
